<template>
    <div class="matrix-box" v-if="data" @click="edit">
        <div class="matrix-list" v-if="!editing">
            <!-- {{ data }} -->
            <latex :text="data" :key="data" />
            <!-- <div class="matrix-row">
                <span class="grid" v-for="item in row">{{ item }} </span>
            </div> -->
        </div>
        <textarea class="input" ref="input" v-model="textData" @blur="onBlur" placeholder="空格分开" v-if="editing"></textarea>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                editing: false,
                textData: '',
                data: null,
                open: false,
                docked: true,
                latex: '\\sqrt{2}'
            }
        },
        props: {
            value: {
            }
        },
        mounted() {
            // console.log(1212)
            // console.log(this.value)
            this.textData = this.value
            this.data = this.getMaterix(this.value)
        },
        methods: {
            onBlur() {
                this.editing = false
                this.data = this.getMaterix(this.textData)
                this.$emit('input', this.textData)
            },
            edit() {
                this.editing = true
                this.$nextTick(() => {
                    this.$refs.input.focus()
                })
            },
            toggle() {
                // console.log(this.$refs.page)
            },
            getMaterix(text) {
                // console.log('解析矩阵', text)
                let ret = []
                let arr = text.split('\n')
                for (let item of arr) {
                    // console.log('item', item.split(/\s+/).join(' & ') + ' \\\\')
                    ret.push(item.split(/\s+/).join(' & ') + ' \\\\')
                }
                let latex = `\\begin{bmatrix}
${ret.join('\n')}
\\end{bmatrix}              
                `
                // console.log('latex', latex)
                // return ret
//                 \\begin{bmatrix}
//    a & b & 1 \\\\
//    c & d & b \\\\
//    1 & 2 & 2 \\\\
// \\end{bmatrix}
                return latex
            }
        },
        watch: {
            value(value) {
                // console.log('matrix change', value)
                this.data = this.getMaterix(value)
                this.textData = value
                // katex.render(this.text, this.$refs.asd, {
                //     throwOnError: false
                // })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .matrix-list {
        cursor: text;
        .row {

        }
        .grid {
            display: inline-block;
            width: 80px;
            height: 80px;
            text-align: center;
            border: 1px solid #999;
        }
    }
    .matrix-box {
        // width: 300px;
        // height: 300px;
        // border: 1px solid #f00;
    }
    .input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        padding: 16px;
        resize: none;
        font-size: 24px;
        border: 1px solid #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/matrix/page.vue